import { maxLength, prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { RateLine } from "../../rates/_types/rate-line";
import { Transaction } from "./transaction";
import { TransactionLineTemplate } from "./transaction-line-template";
import { Job } from "../../cases/_types/job";
import { Capability } from "../../companies/_types/capability";

export class TransactionLine extends Resource {
    public override type = 'transactionLines';
    

    @prop()
    @required()
    public transactionId!: string;

    @propObject(Transaction)
    public transaction!: Transaction;


    @prop()
    public transactionLineTemplateId?: string;

    @propObject(TransactionLineTemplate)
    public transactionLineTemplate!: TransactionLineTemplate;
 
    @prop()
    @required()
    public lineNumber!: number;    

    @prop()
    public isGroup: boolean = false;

    @prop()    
    public rateLineId!: string ;    

    @propObject(RateLine)
    public rateLine!: RateLine;
    
    @prop()        
    public rateLineCode!: string ;  
    @prop()        
    public rateLineDescription!: string ;  
    
    @prop()    
    public jobId!: string ;    

    @propObject(Job)
    public job!: Job;

    @prop() 
    @maxLength({value: 2000})       
    public description!: string ;  

    @prop()        
    public templateLineData?: string ;  

    @prop()    
    public quantity!: number;

    @prop()    
    public price!: number;

    @prop()
    public discountPercent!: number; 

    @prop()
    public discountAmount!: number;
    
    @prop()
    public taxPercent: number = 21;

    @prop()
    public taxAmount!: number;

    @prop()    
    public subtotal!: number;     
    
    @prop()
    public caseServiceId!: string;

    
    @prop()    
    public incrementAmount!: number;     
    @prop()    
    public incrementPercent!: number;     


    @prop()
    public capabilityId!: string;

    @propObject(Capability)
    public capability!: Capability;
}